module.exports = __webpack_public_path__ + "static/2-004ad97cd05200c4e76f10c789a3ba3f.png";